export const getEnv = (varname) => {
    return import.meta.env[`VITE_APP_${varname}`];
};
